import { type TomBadge } from '@/ui/primitives/estilos';
import { type PendenciaCadastro, type RegimeTributario } from '@fiscoai/contracts';

export const REGIME: Record<RegimeTributario, string> = {
  SIMPLES_NACIONAL: 'Simples Nacional',
  MEI: 'MEI',
  LUCRO_PRESUMIDO: 'Lucro Presumido',
  LUCRO_REAL: 'Lucro Real',
};

export const CRT: Record<string, string> = {
  '1': '1 — Simples Nacional',
  '2': '2 — Simples, excesso de sublimite',
  '3': '3 — Regime normal',
  '4': '4 — MEI',
};

export const PENDENCIA: Record<PendenciaCadastro, { rotulo: string; tom: TomBadge }> = {
  SEM_REGIME_VIGENTE: { rotulo: 'Sem regime vigente', tom: 'alerta' },
  SEM_INSCRICAO_ESTADUAL: { rotulo: 'Sem inscrição estadual', tom: 'alerta' },
  SEM_CNAE_PRINCIPAL: { rotulo: 'Sem CNAE principal', tom: 'neutro' },
  SEM_CONTADOR: { rotulo: 'Sem contador', tom: 'neutro' },
  SEM_ENDERECO: { rotulo: 'Sem endereço', tom: 'neutro' },
  CERTIFICADO_VENCENDO: { rotulo: 'Certificado vencendo', tom: 'alerta' },
  CERTIFICADO_VENCIDO: { rotulo: 'Certificado vencido', tom: 'perigo' },
};

export const opcoesDe = (mapa: Record<string, string>) =>
  Object.entries(mapa).map(([valor, rotulo]) => ({ valor, rotulo }));
